import React from "react";

/**
 * Single placeholder card. Reuses the exact `.item-card` / `.item-card-details`
 * DOM structure (image, corner heart, title, description, meta line, price,
 * footer CTA) so every gray block sits exactly where its real content would.
 */
const ProductCardSkeleton = () => (
  <div className="col-lg-2" aria-hidden="true">
    <div className="item-card item-card--skeleton">
      <div className="item-card-details">
        <div className="card-img">
          <div className="item-card-details__corner">
            <div className="skeleton item-card-skeleton__corner" />
          </div>
          <div className="skeleton item-card-skeleton__image" />
        </div>

        <div className="desc">
          <span className="product-info">
            <div className="skeleton item-card-skeleton__line item-card-skeleton__line--title" />
            <div className="skeleton item-card-skeleton__line item-card-skeleton__line--title-short" />
            <div className="skeleton item-card-skeleton__line item-card-skeleton__line--desc" />
            <div className="skeleton item-card-skeleton__line item-card-skeleton__line--meta" />
          </span>
          <div className="kosher-and-price">
            <div className="price-main-cont">
              <div className="skeleton item-card-skeleton__line item-card-skeleton__line--price" />
            </div>
          </div>
        </div>

        <div className="item-card-details__footer">
          <div className="skeleton item-card-skeleton__cta" />
        </div>
      </div>
    </div>
  </div>
);

/** Mirrors `.category-section-header` (the "קמח נפלאות"-style group title) that
 * sits in row 1, above the first row of real cards, so the skeleton reserves
 * the same vertical space instead of the card grid starting higher/lower. */
const CategorySectionHeaderSkeleton = () => (
  <div className="category-section-header" aria-hidden="true">
    <h1>
      <span className="skeleton item-card-skeleton__line item-card-skeleton__line--section-title" />
    </h1>
  </div>
);

/** Grid of placeholder cards shown while a product list is being fetched. */
const ProductsLoadingGrid = ({ count = 12, withHeader = false }) => (
  <>
    {withHeader && <CategorySectionHeaderSkeleton />}
    {Array.from({ length: count }, (_, index) => (
      <ProductCardSkeleton key={index} />
    ))}
  </>
);

export default ProductsLoadingGrid;
